// Mirrors backend SUPPORTED_LANGUAGES — do not add codes the backend doesn't support.
export const LANGUAGE_META: Record<string, { label: string; flag: string }> = {
  en: { label: 'English',    flag: '🇬🇧' },
  ru: { label: 'Russian',    flag: '🇷🇺' },
  de: { label: 'German',     flag: '🇩🇪' },
  fr: { label: 'French',     flag: '🇫🇷' },
  es: { label: 'Spanish',    flag: '🇪🇸' },
  it: { label: 'Italian',    flag: '🇮🇹' },
  pt: { label: 'Portuguese', flag: '🇵🇹' },
  ja: { label: 'Japanese',   flag: '🇯🇵' },
  zh: { label: 'Chinese',    flag: '🇨🇳' },
  ko: { label: 'Korean',     flag: '🇰🇷' },
}

export function getLangMeta(code: string): { label: string; flag: string } {
  return LANGUAGE_META[code] ?? { label: code.toUpperCase(), flag: '🌐' }
}

// Interface and native-language lists derive from the language registry
// (i18n/registry.ts, ADR-111), not from a list here.

/**
 * Target languages shown on onboarding step 2.
 * available=false → rendered disabled with "coming soon" indicator.
 * Native-name display, no flags.
 */
export const ONBOARDING_TARGET_LANGUAGES = [
  { code: 'en', nativeName: 'English',   available: true  },
  { code: 'de', nativeName: 'Deutsch',   available: false },
  { code: 'fr', nativeName: 'Français',  available: false },
  { code: 'es', nativeName: 'Español',   available: false },
] as const

/**
 * Pairs where content exists, in "<source>-<target>" format.
 * Mirrors backend SUPPORTED_LANGUAGE_PAIRS — update both when adding a pair.
 * Used client-side to guard the onboarding submit before the API call.
 */
export const SUPPORTED_LANGUAGE_PAIRS: readonly string[] = [
  'ru-en', 'fr-en', 'es-en', 'de-en', 'pt-en',
  'en-en',
  'ru-de',
] as const
